<aside
    *ngIf="visible"
    class="rail d-flex"
    [class.rail--expanded]="expanded"
    [class.rail--pinned]="pinned"
    (mouseenter)="onHover(true)"
    (mouseleave)="onHover(false)">
    <nav class="rail-nav">
        <ng-container *ngFor="let group of groups; trackBy: trackGroup">
            <div class="rail-group">
                <div class="rail-group-title" aria-hidden="true">{{ group.title }}</div>
                <ng-container *ngFor="let item of group.items; trackBy: trackItem">
                    <a *ngIf="!item.disabledReason"
                       class="rail-item"
                       [routerLink]="item.route"
                       routerLinkActive="rail-item--active"
                       [title]="item.label">
                        <ng-icon [name]="item.icon" size="18" class="rail-item-icon"></ng-icon>
                        <span class="rail-item-label">{{ item.label }}</span>
                    </a>
                    <span *ngIf="item.disabledReason"
                          class="rail-item rail-item--disabled"
                          aria-disabled="true"
                          [title]="item.disabledReason">
                        <ng-icon [name]="item.icon" size="18" class="rail-item-icon"></ng-icon>
                        <span class="rail-item-label">{{ item.label }}</span>
                        <ng-icon name="lucideLock" size="12" class="rail-item-lock"></ng-icon>
                    </span>
                </ng-container>
            </div>
        </ng-container>
    </nav>
    <button class="rail-item rail-pin" type="button" (click)="togglePin()"
            [title]="pinned ? 'Unpin menu' : 'Pin menu open'">
        <ng-icon [name]="pinned ? 'lucidePinOff' : 'lucidePin'" size="18" class="rail-item-icon"></ng-icon>
        <span class="rail-item-label">{{ pinned ? 'Unpin' : 'Pin' }}</span>
    </button>
</aside>

<nav *ngIf="visible" class="settings-breadcrumb" aria-label="Breadcrumb">
    <ol class="settings-breadcrumb-list">
        <li class="settings-breadcrumb-item">
            <a *ngIf="!onLandingPage" [routerLink]="landingRoute" class="settings-breadcrumb-link">Settings</a>
            <span *ngIf="onLandingPage" class="settings-breadcrumb-current">Settings</span>
        </li>
        <li *ngFor="let crumb of pageCrumbs; let last = last" class="settings-breadcrumb-item"
            [attr.aria-current]="last ? 'page' : null">
            <span class="settings-breadcrumb-sep" aria-hidden="true">/</span>
            <a *ngIf="!last && crumb.route" [routerLink]="crumb.route" class="settings-breadcrumb-link">{{ crumb.label }}</a>
            <span *ngIf="last || !crumb.route" class="settings-breadcrumb-current">{{ crumb.label }}</span>
        </li>
    </ol>
</nav>
